// Words the project pages share, so a count or a standard reads the same on every page.

/** "GRIHA v6.0" from the standard's name ("GRIHA") and version ("6.0"). QA 2026-09-29 found it
 * written three ways (GRIHA / GRIHA 6.0 / GRIHA v6.0); the Create Project popup's "GRIHA v6.0"
 * is the form kept. */
export function standardLabel(name, version) {
  if (!name) return '';
  if (!version) return name;
  return `${name} ${/^v/i.test(version) ? version : `v${version}`}`;
}

/** A project's videos and photo sets, counted together: "1 video or photo set", "3 videos &
 * photos" (Anshul, 2026-09-30, after QA found photo sets counted as "videos"). */
export function itemCountLabel(count) {
  const n = count ?? 0;
  return n === 1 ? '1 video or photo set' : `${n} videos & photos`;
}

/** "1 run", "2 runs" (QA 2026-09-29: "1 videos / 1 runs"). */
export function runCountLabel(count) {
  const n = count ?? 0;
  return `${n} ${n === 1 ? 'run' : 'runs'}`;
}
